import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {stopPropagation} from '../../../utils/dom-helpers';
import i18n from '../../../utils/i18n';
import {
  default as TextInput,
  Behaviors as TextInputBehaviors,
  InputUITypes,
  ValidationTypes
} from '@adsk/bim360-matrix-react-text-input';
import {
  issueRootCauseCategoryInputValidators,
  issueRootCauseInputValidators
} from '../../../utils/issueRootCauses-helpers';

class IssueRootCausesAdminTitle extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || ''
    };
    /* eslint-disable react/no-direct-mutation-state*/
    this.state.editableProps = this.getEditableProps(props);
    /* eslint-enable react/no-direct-mutation-state*/

    this.inputProps = {
      autoselect: !!props.value,
      behavior: TextInputBehaviors.SINGLE_LINE,
      onChange: value => this.setState({value}),
      onInlineEditStart: () => this.props.onTitleEditStart(),
      onInlineEditEnd: (value, isCancel, previousValue, finisher, valid) => {
        if (valid || value.length === 0) {
          value.length > 0 && !isCancel && this.onChangeEnd(value);
          this.setState({value: this.props.value || ''});
          this.props.onTitleEditEnd();
        }
      },
      className: 'IssueRootCausesAdminTitle__input'
    };

    this.onClick = this.onClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({
        value: nextProps.value || '',
        editableProps: this.getEditableProps(nextProps)
      });
    }
    if (this.props.currentTitleEditedRootCauseId !== nextProps.currentTitleEditedRootCauseId) {
      this.setState({editableProps: this.getEditableProps(nextProps)});
    }
  }

  getEditableProps(props) {
    const editableClassName = cx('IssueRootCausesAdminTitle__editable', {
      'IssueRootCausesAdminTitle__editable--add-root-cause': !props.entityId
    });

    return {
      startInEdit: false,
      inEdit: props.currentTitleEditedRootCauseId && props.currentTitleEditedRootCauseId === props.entityId,
      onEditModeChanged: isInEditMode => {
        this.setState({editableProps: {...this.state.editableProps, inEdit: isInEditMode}});
        props.onFinishEdit && props.onFinishEdit();
      },
      showEditableIcon: !!props.entityId,
      className: editableClassName,
      multiline: false
    };
  }

  createRootCause(title) {
    this.props.createIssueRootCauseAction({
      parentId: this.props.parentId,
      title: title.trim(),
      clientID: this.props.clientID,
      isActive: this.props.parentStatus
    });
    this.props.onCreate();
  }

  setTitle(id, value) {
    this.props.updateIssueRootCausesTitleAction(id, value, this.props.parentId);
  }

  getValidationProps() {
    const issueRootCausesNames = this.props.issueRootCausesNames.filter(
      name => name !== this.props.value.toLowerCase()
    );
    return {
      type: ValidationTypes.POPOVER,
      ignore: this.props.value === this.state.value,
      validator: this.props.isParent
        ? issueRootCauseCategoryInputValidators(issueRootCausesNames)
        : issueRootCauseInputValidators(issueRootCausesNames),
      required: true,
      typeProps: {
        container: this.props.container,
        tooltipClassName: 'IssueRootCausesAdminTitle__popover'
      }
    };
  }

  onChangeEnd(value) {
    if (this.props.value && value && this.props.value !== value) {
      this.setTitle(this.props.entityId, value);
    } else if (!this.props.value) {
      this.createRootCause(value);
    }
  }

  onClick(event) {
    if (!this.props.isReadOnly) {
      stopPropagation(event);
    }
  }

  _renderTitle() {
    return <span className="IssueRootCausesAdminTitle__title">{this.props.value}</span>;
  }

  _renderInput() {
    // When editing an existing category / root cause, don't show placeholder
    const placeholder = this.props.entityId ? '' : i18n.t('issueRootCauses.actions.addRootCause');
    return (
      <TextInput
        placeholder={placeholder}
        inputUIType={InputUITypes.INLINE_EDIT}
        validationProps={this.getValidationProps()}
        editableProps={this.state.editableProps}
        inputProps={this.inputProps}
        value={this.state.value}
      />
    );
  }

  render() {
    return (
      <span className="IssueRootCausesAdminTitle" onClick={this.onClick}>
        {this.props.isReadOnly ? this._renderTitle() : this._renderInput()}
      </span>
    );
  }
}

IssueRootCausesAdminTitle.displayName = 'IssueRootCausesAdminTitle';

IssueRootCausesAdminTitle.defaultProps = {
  parentStatus: null,
  isReadOnly: false
};

IssueRootCausesAdminTitle.propTypes = {
  value: PropTypes.string,
  entityId: PropTypes.string,
  parentId: PropTypes.string,
  issueRootCausesNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  container: PropTypes.object.isRequired,
  parentStatus: PropTypes.bool,
  isParent: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool,
  createIssueRootCauseAction: PropTypes.func.isRequired,
  updateIssueRootCausesTitleAction: PropTypes.func.isRequired,
  clientID: PropTypes.string,
  onTitleEditStart: PropTypes.func.isRequired,
  onTitleEditEnd: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  currentTitleEditedRootCauseId: PropTypes.string.isRequired,
  onFinishEdit: PropTypes.func.isRequired
};

export default IssueRootCausesAdminTitle;
